import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatFeeEmployeejobModel } from 'src/app/model/cat-fee-employee-job-model';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CatFeeEmployeeJobService } from 'src/oldApp/services/cat-fee-employee-job.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalFeeEmployeeJobComponent } from 'src/oldApp/shared/modal-fee-employee-job/modal-fee-employee-job.component';

@Component({
  selector: 'app-cat-fee-employee-job',
  templateUrl: './cat-fee-employee-job.component.html',
  styleUrls: ['./cat-fee-employee-job.component.css']
})
export class CatFeeEmployeeJobComponent implements OnInit {
  // estado pagina
  public page:string='CatFeeEmployeeJob';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public fees:CatFeeEmployeejobModel[]=[];

  // catalogs
  public employeeJobCatalog:CatEmployeeJobModel[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private creator:CreatorService,
    private modalService:NgbModal,
    private catFeeEmployeeJobService:CatFeeEmployeeJobService,
    private catEmployeeJobService:CatEmployeeJobService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  // 
  add=()=> {
    let fee=this.creator.newCatFeeEmployeeJob();
    let modalRef=this.modalService.open(ModalFeeEmployeeJobComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.fee={...fee};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(fee:CatFeeEmployeejobModel)=> {
    let modalRef=this.modalService.open(ModalFeeEmployeeJobComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.fee={...fee};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  jobDescription=fee=> {
    let emp=this.employeeJobCatalog.find(e=> e.employeeJobId===fee.employeeJobId);
    return emp?emp.description:'';
  }

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.catFeeEmployeeJobService.getAll(),
      this.catEmployeeJobService.getAll()
    )
    .pipe(
      tap(([feesResp, jobsResp]:[any, any])=> {
        this.fees=feesResp.data;
        this.employeeJobCatalog=jobsResp.data;
        this.viewStatus=1;
      }),
      catchError(error=> {
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
      })
    )
    .subscribe();
  }
}
